import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

// import { NameSearchRegisterItem } from '../../providers/storage/';

import { Product } from '../../models/product';

import { DetailPage } from '../detail/detail';
import { PageBase } from '../page-base';
import { DataProvider } from '../../providers/data/data';
import { ProductProvider } from '../../providers/product/product';
import { CompanyConfigProvider } from '../../providers/company-config/company-config';

@IonicPage()
@Component({
  selector: 'page-search',
  templateUrl: 'search.html',
})
export class SearchPage extends PageBase {

  products = new Array<Product>();
  isSearching = false;

  showPrice : boolean;

  constructor(private navCtrl: NavController,
    private productProvider: ProductProvider,
    private companyConfigProvider: CompanyConfigProvider) {
    super();

    companyConfigProvider.canSeePrice().then(x => {
      this.showPrice = x;
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SearchPage');
  }

  /**
  * Opens detail page for specified product.
  */
  openDetail(item: Product) {
    this.navCtrl.push(DetailPage, { "product": item });
  }

  textFilter: string;
  page = 0;

  /**
  * Loads products for text filter.
  */
  async getItems(ev: any) {
    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.textFilter = val.toLowerCase();
      // Reset the page number
      this.page = 0;
      // Empty list
      this.products = new Array<Product>();
      // Show loader
      this.isSearching = true;
      // Get products
      this.products = await this.productProvider.getProducts({ textFilter: this.textFilter, page: this.page }, );
      // Unshow loader
      this.isSearching = false;
    } else {
      // Empty search value. Empty list.
      this.isSearching = false;
      this.products = new Array<Product>();
    }
  }

  loadNewPage(infiniteScroll) {
    this.page++;
    this.productProvider.getProducts({ textFilter: this.textFilter, page: this.page }, ).then(x => {
      x.forEach(p => this.products.push(p));
      infiniteScroll.complete();
    });
  }
}


// WEBPACK FOOTER //
// ./src/pages/search/search.ts